import { Suspense, lazy, useEffect, useState } from "react";
import Loading from "./Pages/Loading";
import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import FeaturedCreators from "./Pages/home/FeaturedCreators";
import StreamSetting from "./Pages/dashboard/StreamSetting";
import SettingLayout from "./Pages/dashboard/layout/SettingLayout";
import apisecured from "./api/apisecured";
import { setLogin } from "./State/authSlicer";
import NotificationSetting from "./Pages/dashboard/NotificationSetting";
import NewHome from "./Pages/home/NewHome";
import ChatBotSetting from "./Pages/dashboard/ChatBotSetting";
import IntegrationsSetting from "./Pages/dashboard/IntegrationsSetting";
import DonothonTimerSetting from "./Pages/dashboard/DonothonTimerSetting";
import MaintenancePage from "./Pages/MaintenancePage";
import ForOtherUserOnly from "./Pages/dashboard/ForOtherUserOnly";
import ReferalSignUp from "./Pages/account/ReferalSignUp";
import Referral from "./Pages/dashboard/Referral";
import NewDashLayout from "./Pages/dashboard/NewLayout/NewDashLayout";
import ProfileSettingPage from "./Pages/dashboard/NewPages/ProfileSettingPage";
import PaymentSettingPage from "./Pages/dashboard/NewPages/PaymentSettingPage";
import StreamSettingPage from "./Pages/dashboard/NewPages/StreamSettingPage";
import NotificationsSettingPage from "./Pages/dashboard/NewPages/NotificationsSettingPage";
import ChatbotSettingPage from "./Pages/dashboard/NewPages/ChatbotSettingPage";
import IntegrationsSettingPage from "./Pages/dashboard/NewPages/IntegrationsSettingPage";
const CookiesYes = lazy(() => import("./Pages/home/CookiesYes"));
const StreamAlertNew = lazy(
  () => import("./components/Dashcomponents/New/StreamAlert"),
);
const GoalOverlayContainer = lazy(
  () => import("./components/custom-ui/GoalOverlayContainer"),
);
const Error = lazy(() => import("./Pages/Error"));
const Explore = lazy(() => import("./Pages/dashboard/Explore"));
const User = lazy(() => import("./Pages/dashboard/User"));
const OtherUser = lazy(() => import("./Pages/dashboard/OtherUser"));

const OtherUserCurrentGoals = lazy(
  () => import("./Pages/dashboard/OtherUserCurrentGoals"),
);
const OtherUserTotalEarnings = lazy(
  () => import("./Pages/dashboard/OtherUserTotalEarnings"),
);
const CurrentGoalUser = lazy(() => import("./Pages/dashboard/CurrentGoalUser"));
const CompletedGoalUser = lazy(
  () => import("./Pages/dashboard/CompletedGoalUser"),
);
const PaymentSetting2 = lazy(() => import("./Pages/dashboard/PaymentSetting2"));
const PaymentSuccess = lazy(() => import("./Pages/dashboard/PaymentSuccess"));
const PaymentFailure = lazy(() => import("./Pages/dashboard/PaymentFailure"));
const PrivacyPolicy = lazy(() => import("./Pages/home/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./Pages/home/TermsOfService"));

const AuthenticateLayout = lazy(
  () => import("./Pages/account/Layout/AuthenticateLayout"),
);

const HomeLayout = lazy(() => import("./Pages/home/Layout/HomeLayout"));
const PrivateRoutes = lazy(() => import("./Pages/PrivateRoutes"));
const LoginAuthRoute = lazy(() => import("./Pages/LoginAuthRoute"));
const FundGoal = lazy(() => import("./Pages/dashboard/FundGoal"));
const FundGoalUser = lazy(() => import("./Pages/dashboard/FundGoalUser"));
const AccountLayout = lazy(
  () => import("./Pages/account/Layout/AccountLayout"),
);
const DashIndex = lazy(() => import("./Pages/dashboard/DashIndex"));
const EmailVerification = lazy(
  () => import("./Pages/account/EmailVerification"),
);
const Login = lazy(() => import("./Pages/account/Login"));
const OTPVerification = lazy(() => import("./Pages/account/OTPVerification"));
const SuccessEmailVerification = lazy(
  () => import("./Pages/account/SuccessEmailVerification"),
);
const ResetPassword = lazy(() => import("./Pages/account/ResetPassword"));
const ProfileSetting = lazy(() => import("./Pages/dashboard/ProfileSetting"));
const PaymentSetting = lazy(() => import("./Pages/dashboard/PaymentSetting"));
const AccountSetting = lazy(() => import("./Pages/dashboard/AccountSetting"));
const BannerDashLayout = lazy(
  () => import("./Pages/dashboard/layout/BannerDashLayout"),
);
const BannerIndex = lazy(() => import("./Pages/dashboard/BannerIndex"));
const CompletedGoals = lazy(() => import("./Pages/dashboard/CompletedGoals"));
// const Insights = lazy(() => import("./Pages/dashboard/Insights"));
const GoalsOverview = lazy(() => import("./Pages/dashboard/GoalsOverview"));
const Notification = lazy(() => import("./Pages/dashboard/Notification"));
function App() {
  const dispatch = useDispatch();
  const [apiDown, setApiDown] = useState(false);
  const [healthChecked, setHealthChecked] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const checkHealth = async () => {
      try {
        await apisecured.get("/account/health");
        setApiDown(false);
      } catch (error) {
        console.error("API health check failed:", error);
        setApiDown(true);
      } finally {
        setHealthChecked(true);
      }
    };

    checkHealth();
  }, []);

  useEffect(() => {
    if (healthChecked && apiDown && location.pathname !== "/maintenance") {
      navigate("/maintenance");
    }
  }, [healthChecked, apiDown, navigate, location]);
  useEffect(() => {
    // Function to call the profile endpoint
    const fetchUserProfile = async () => {
      try {
        const response = await apisecured.get("account/profile");
        if (response.status === 200) {
          // Dispatch the setLogin action with data returned from the profile endpoint.
          dispatch(
            setLogin({
              email: response.data.email,
              uid: response.data.uid,
              displayName: response.data.displayName,
              sponsaUserName: response.data.sponsaUserName,
              userImg: response.data.userImg,
              CoverIMG: response.data.coverIMG,
              accountType: response.data.accountType,
              YtUrl: response.data.ytUrl,
              TwitterUrl: response.data.twitterUrl,
              InstaUrl: response.data.instaUrl,
              FbUrl: response.data.fbUrl,
              bio: response.data.bio,
              role: response.data.role,
              IsGoogleAccount: response.data.isGoogleAccount,
              currency: response.data.currency,
              stripeID: response.data.stripeID,
              stripeConnectedEmail: response.data.stripeConnectedEmail,
              paypalID: response.data.paypalID,
              paypalConnectedEmail: response.data.paypalConnectedEmail,
              isverified: response.data.isVerified,
              isAuthenticated: response.data.isAuthenticated,
              ReceiveAllTips: response.data.receiveAllTips,
              ReceiveGoalFunded: response.data.receiveGoalFunded,
              socialLinks: response.data.socialLinks || [],
              selectedTags: response.data.selectedTags || [],
              isYouTubeConnected: response.data.youtubeConnected,
              youtubeEmail: response.data.youtubeConnectedEmail,
              isTwitchConnected: response.data.twitchConnected,
              twitchEmail: response.data.twitchConnectedEmail,
              isTwitterConnected: response.data.twitterConnected,
              twitterUsername: response.data.twitterConnectedUsername,
              ryftSubAccountID: response.data.ryftSubAccountID,
            }),
          );
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, [dispatch]);
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<HomeLayout />}>
          <Route index exact element={<NewHome />} />
          {/* <Route path="newhome" element={<NewHome />} /> */}
          <Route
            path="featured-creators"
            exact
            element={<FeaturedCreators />}
          />
        </Route>
        {/* this is new dahbaord shell with new dashboard pages */}
        <Route path="/" element={<NewDashLayout />}>
          <Route path="profile-setting" element={<ProfileSettingPage />} />
          <Route path="/payment-setting" element={<PaymentSettingPage />} />
          <Route path="/stream-setting" element={<StreamSettingPage />} />
          <Route
            path="/notifications-setting"
            element={<NotificationsSettingPage />}
          />
          <Route path="/chatbot-setting" element={<ChatbotSettingPage />} />
          <Route
            path="/integrations-setting"
            element={<IntegrationsSettingPage />}
          />
        </Route>
        {/* this is new dahbaord shell with new dashboard pages */}

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookieyes-generated-policy" element={<CookiesYes />} />
        <Route path="/overlay" element={<GoalOverlayContainer />} />
        <Route path="/streamalerts" element={<StreamAlertNew />} />

        <Route element={<LoginAuthRoute />}>
          <Route path="/account" element={<AccountLayout />}>
            <Route index exact element={<Login />} />
            <Route path="login/:email?" element={<Login />} />
          </Route>
          <Route path="/signup" element={<ReferalSignUp />}>
            <Route index exact element={<ReferalSignUp />} />
            <Route path="OTP-verification" element={<OTPVerification />} />
          </Route>
        </Route>
        <Route path="/authentication" element={<AuthenticateLayout />}>
          <Route path="email-verification" element={<EmailVerification />} />
          {/* <Route path="OTP-verification" element={<OTPVerification />} /> */}
          <Route
            path="email-verification-success"
            element={<SuccessEmailVerification />}
          />
          <Route path="reset-password" element={<ResetPassword />} />
        </Route>
        <Route element={<PrivateRoutes />}>
          <Route element={<NewDashLayout />}>
            <Route path="/dashboard/" index element={<DashIndex />} />
            <Route path="/referral-codes" exact element={<Referral />} />
            <Route path="explore" element={<Explore />} />
            <Route element={<SettingLayout />}>
              <Route
                path="profile-setting"
                exact
                element={<ProfileSetting />}
              />
              <Route path="stream-setting" exact element={<StreamSetting />} />
              <Route
                path="chatbot-setting"
                exact
                element={<ChatBotSetting />}
              />
              <Route
                path="integrations-setting"
                element={<IntegrationsSetting />}
              />
              <Route
                path="donothon-timer-setting"
                exact
                element={<DonothonTimerSetting />}
              />
              <Route path="payment-setting" element={<PaymentSetting />} />
              <Route
                path="notifications-setting"
                element={<NotificationSetting />}
              />
            </Route>
            <Route path="payment-setting2" element={<PaymentSetting2 />} />
            <Route
              path="payment-success/:session_id"
              element={<PaymentSuccess />}
            />
            <Route path="payment-failure" element={<PaymentFailure />} />
            <Route path="account-setting" exact element={<AccountSetting />} />
            <Route path="insights" element={<DashIndex />} />
            <Route path="goals-overview" element={<GoalsOverview />} />
            <Route path="notification" element={<Notification />} />
            {/* <Route path="user/:uid/" element={<OtherUser />}> */}
            <Route path="user/:username/" element={<OtherUser />}>
              <Route path="current-goals" element={<OtherUserCurrentGoals />} />
              <Route
                path="current-goals/:goaluuid"
                element={<CurrentGoalUser />}
              />
              <Route
                path="completed-goals/:goaluuid"
                element={<CompletedGoalUser />}
              />
              <Route path="fund-goal/:goaluuid" element={<FundGoalUser />} />
              <Route
                path="total-earnings"
                element={<OtherUserTotalEarnings />}
              />
            </Route>
          </Route>

          {/* <Route element={<DashLayout />}> */}
          <Route element={<NewDashLayout />}>
            <Route path=":username/" element={<BannerDashLayout />}>
              <Route index element={<Navigate to="current-goals" replace />} />
              <Route path="tips/" element={<ForOtherUserOnly />} />
              <Route path="user/:useruid" element={<User />} />
              <Route path="current-goals" element={<BannerIndex />} />
              <Route path="completed-goals" element={<CompletedGoals />} />
              <Route
                path="current-goals/:goaluuid"
                element={<CurrentGoalUser />}
              />
              <Route
                path="completed-goals/:goaluuid"
                element={<CompletedGoalUser />}
              />
              <Route path="fund-goal/:goaluuid" element={<FundGoal />} />
            </Route>
          </Route>
        </Route>
        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Suspense>
  );
}

export default App;
